import { render, staticRenderFns } from "./Stadtspital.vue?vue&type=template&id=645a5474"
import script from "./Stadtspital.vue?vue&type=script&lang=js"
export * from "./Stadtspital.vue?vue&type=script&lang=js"
import style0 from "./Stadtspital.vue?vue&type=style&index=0&id=645a5474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports